import SEO from '../components/SEO';
import APIDocsPage from '../components/APIDocsPage';

export default function APIDocsPageSEO() {
  const handleBack = () => {
    window.location.href = '/';
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "APIReference",
    "name": "JsonToonCraft REST API",
    "description": "REST API for converting JSON to TypeScript, Zod schemas, OpenAPI specifications, and TOON format. Free tier available with 10,000 requests/month.",
    "provider": {
      "@type": "Organization",
      "name": "JsonToonCraft",
      "url": "https://jsontooncraft.com"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "description": "Free tier: 10,000 requests/month, 500 requests/hour"
    }
  };

  return (
    <>
      <SEO
        title="API Documentation - REST API for JSON Conversion | JsonToonCraft"
        description="JsonToonCraft REST API documentation. Convert JSON to TypeScript, Zod, OpenAPI, and TOON format programmatically. Free tier: 10,000 requests/month. Rate limited, secure, CORS enabled."
        keywords="JSON API, TypeScript API, conversion API, REST API, Zod API, OpenAPI API, TOON API, JSON converter API"
        canonicalUrl="https://jsontooncraft.com/docs"
        structuredData={structuredData}
      />

      <APIDocsPage onBack={handleBack} />
    </>
  );
}
